export default function objectToOptions(items) {
   return Object.entries(items).map(([key, value]) => {
       let id = key;
       if (key === 'null') id = null;
       return {id, text: value}
   })
}
